import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  Center,
  forwardRef,
  IconButton,
  IconButtonProps,
  TabList,
  TabPanel,
  TabPanels,
  TabProps,
  Tabs,
  TabsProps,
  useMultiStyleConfig,
  useTab,
} from '@chakra-ui/react';
import React from 'react';

interface CarouselProps extends Omit<TabsProps, 'variant' | 'index'> {
  showControl?: boolean;
}

const CircleTab = forwardRef<TabProps, 'div'>((props, ref) => {
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps['aria-selected'];

  const styles = useMultiStyleConfig('Tabs', tabProps);

  return (
    <Box
      as="button"
      __css={styles.tab}
      {...tabProps}
      role="group"
      borderBottom={'none'}
    >
      <Box
        borderRadius="full"
        _groupHover={{ backgroundColor: '003366' }}
        background={isSelected ? '#003366' : '#DBD9D7'}
        borderBottom="none"
        width="6px"
        height="6px"
      />
    </Box>
  );
});

const CarouselControl: React.FC<IconButtonProps> = ({ children, ...props }) => (
  <IconButton colorScheme="blue" fontSize="2em" isRound {...props}>
    {children}
  </IconButton>
);

const CarouselV2: React.FC<CarouselProps> = ({
  children,
  showControl,
  onChange,
  ...rest
}) => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const componentCount = React.Children.count(children);

  const handleOnChange = React.useCallback(
    (index: number) => {
      if (showControl) {
        setTabIndex(index);
      }
      // onChange?.(index);
    },
    [onChange, showControl],
  );
  const incrementOnClick = React.useCallback(() => {
    const newIndex = tabIndex === componentCount - 1 ? 0 : tabIndex + 1;
    setTabIndex(newIndex);
    onChange && onChange(newIndex);
  }, [tabIndex]);
  const decrementOnClick = React.useCallback(() => {
    const newIndex = tabIndex === 0 ? componentCount - 1 : tabIndex - 1;
    setTabIndex(newIndex);
    onChange && onChange(newIndex);
  }, [tabIndex]);

  return (
    <Center position="relative" width="full">
      <Tabs
        display="flex"
        alignItems="center"
        variant="dots"
        index={showControl ? tabIndex : undefined}
        onChange={handleOnChange}
        width="full"
        {...rest}
      >
        <Box width="full">
          <TabPanels width="full">
            {React.Children.map(children, (child, i) => (
              <TabPanel key={i} padding={0} width="full">
                {child}
              </TabPanel>
            ))}
          </TabPanels>
          <TabList>
            {React.Children.map(children, (_, i) => (
              <CircleTab key={i} />
            ))}
          </TabList>
        </Box>
      </Tabs>
      {showControl && (
        <Box
          position="absolute"
          justifyContent="space-between"
          zIndex="2"
          display="flex"
          // width={{ base: '97%', sm: '450px', md: '600px', lg: '900px' }}
          width={{ base: '90%', sm: '450px', md: '600px', lg: '900px' }}
          bottom="0px"
        >
          <CarouselControl onClick={decrementOnClick} aria-label="Left Control">
            <ChevronLeftIcon />
          </CarouselControl>
          <CarouselControl
            onClick={incrementOnClick}
            aria-label="Right Control"
          >
            <ChevronRightIcon />
          </CarouselControl>
        </Box>
      )}
    </Center>
  );
};

export default CarouselV2;
